import { action, observable, runInAction } from "mobx";
import * as API from "../../../api/teamSharing";
import { Dialog } from "@weapp/ui";
import { mainHost } from "../../../utils";
import { getLabel } from "@weapp/utils";

const { message } = Dialog;
const host = mainHost();
const fileOptions = [
  {
    id: "download",
    icon: "Icon-download02",
    content: getLabel('123368', '下载'),
  },
  {
    id: "delete",
    icon: "",
    content: getLabel('99524', '删除'),
  },
  {
    id: "preview",
    icon: "Icon-download02",
    content: getLabel('99521', '预览'),
  }
]

export class TeamSharingListStore {
  @observable test: string = "";
  @observable hasMore: boolean = false;
  @observable teamSharingList: Array<any> = [];
  @observable spining: boolean = false;//加载中
  @observable startDate: string = '';
  @observable endDate: string = '';
  @observable keywords: string = '';
  @observable range: string = 'company';
  @observable workType: string = 'share';
  @observable noData: boolean = false;
  @observable noFilterData: boolean = false;
  @observable invitePermission: boolean = false;
  @observable rangeUserId: any = 0;
  @observable rangeUserName: any;
  @observable publishtype: any = 'share';
  @observable shareScope: any = 'all';
  @observable rangeMenus: any = [
    { id: 'company', content: getLabel('62230', '全团队') },
    { id: 'watched', content: getLabel('188013', '关注的同事') },
    { id: 'superiors', content: getLabel('188014', '我上级的') },
    { id: 'directSubordinates', content: getLabel('188015', '直接下属') },
    { id: 'subordinates', content: getLabel('188016', '所有下属') },
    { id: 'department', content: getLabel('188017', '本部门') },
    { id: 'employee', content: getLabel('188018', '人员') },
  ];


  @action
  initData = () => {
    this.getData();
  }

  @action
  checkInvitePermission = () => {
    let formData = new FormData();
    formData.append("userId", window.TEAMS.currentUser.id)
    formData.append("configName", 'inviteForbid')
    API.checkInvitePermission(formData)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            this.invitePermission = result.isContain;
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  @action
  reloadTeamShares = () => {
    this.getData();
  }

  @action
  onPageChange = (value: number) => {
    this.getData(value);
  }

  @action
  getTeamSharingConfig = () => {
    const configValue = window.TEAMS.userConfig?.['portal.workshare'];
    if (configValue) {
      this.range = configValue.split('-')[0];
      this.workType = configValue.split('-')[1];
      this.rangeUserId = configValue.split('-')[2] == 'undefined' ? '' : configValue.split('-')[2];
      if (configValue.split('-')[3] && configValue.split('-')[3] !== 'undefined' && configValue.split('-')[3] !== '') {
        this.rangeUserName = configValue.split('-')[3] == 'undefined' ? '' : configValue.split('-')[3];
      }
      if ((this.rangeUserId && this.rangeUserId !== 0 && this.rangeUserId !== '' && this.rangeUserId !== 'undefined') &&
        (this.rangeUserName && this.rangeUserName !== '' && this.rangeUserName !== 'undefined')) {
        this.rangeMenus.push({ id: this.rangeUserId, content: this.rangeUserName })
        this.range = this.rangeUserId;
      }
    }
  }

  @action
  getData = (pageNo?: number | null) => {
    this.spining = true;
    const params: any = {
      pageSize: 25,
      pageNo: pageNo || 1,
      workDynaFilter: {
        range: this.range,
        workType: this.workType,
        keywords: this.keywords,
        startDate: this.startDate,
        endDate: this.endDate,
      },
    }
    if (this.rangeUserId && this.rangeUserId != 0 && this.rangeUserId != '') {
      params.workDynaFilter['creator'] = this.rangeUserId;
    }
    API.getTeamSharing(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            this.spining = false;
            this.noData = false;
            if (pageNo) {
              this.teamSharingList = this.teamSharingList.concat([...(result.workDynaPage.result || [])]);
            } else {
              this.teamSharingList = [...(result.workDynaPage.result || [])];
            }
            this.handLoadAtParams();
            this.handleFileData();
            if (result.workDynaPage.pageNo === 1 && result.workDynaPage.result.length === 0) {
              this.noData = true;
            }
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  @action
  handleFileData = () => {
    if (this.teamSharingList && this.teamSharingList.length > 0) {
      this.teamSharingList.forEach(data => {
        if (data && data.imageFiles && data.imageFiles.length > 0) {
          data.imageFiles.forEach((item: any) => {
            item.src = `/papi/file/preview?fileId=${item.bigUrl}&type=imgs`;
          })
        }
        if (data && data.attachments && data.attachments.length > 0) {
          data.attachments.forEach((item: any) => {
            item.fileid = item.id;
            item.isImg = item.image;
            item.options = fileOptions;
          })
        }
      })
    }
  }

  @action
  loadMyfollow = () => {
    const params = { pageNo: 1, pageSize: 10, approvedOnly: true };
    API.loadMyfollow(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            if (result.data && result.data.user && result.data.user.superior) {
            } else {
              this.rangeMenus = this.rangeMenus.filter((item: any) => item.id !== 'superiors');
            }
            if (result.data && result.data.page && result.data.page.totalCount) {
            } else {
              this.rangeMenus = this.rangeMenus.filter((item: any) => item.id !== 'watched');
            }
          }
          const params = { pageNo: 1, pageSize: 10 };
          API.loadSubordinate(params)
            .then((result: any) => {
              runInAction(() => {
                if (result) {
                  if (result && result.page && result.page.totalCount) {
                  } else {
                    this.rangeMenus = this.rangeMenus.filter((item: any) => item.id !== 'directSubordinates');
                    this.rangeMenus = this.rangeMenus.filter((item: any) => item.id !== 'subordinates');
                  }
                }
              });
            })
            .catch((error) => {
              console.log(error);
            });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  @action
  delete = (id: any) => {
    API.deleteTeamSharing({ id: id })
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            this.teamSharingList = [...(result.workDynaPage.result || [])];
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  @action
  updateRange = (value: any) => {
    this.range = value;
    this.rangeUserName = '';
    this.rangeUserId = 0;
    this.saveConfig();
    this.getData();
  }

  @action
  updateWorkType = (value: any) => {
    this.workType = value;
    this.saveConfig();
    this.getData();
  }

  @action
  updateKeywords = (value: any) => {
    this.keywords = value;
    this.getData();
  }

  @action
  updateDateRange = (start: any, end: any) => {
    this.startDate = start;
    this.endDate = end;
    this.getData();
  }

  @action
  updateShareScope = (value: any) => {
    this.shareScope = value;
  }

  @action
  updateEmployee = (id: any, name: any) => {
    this.rangeUserId = id;
    this.rangeUserName = name;
    this.saveConfig();
    this.getData();
  }

  buildConfigParams = () => {
    let configValue = '';
    configValue += this.range + "-";
    configValue += this.workType + "-";
    configValue += this.rangeUserId + "-";
    configValue += this.rangeUserName;
    return {
      config: {
        configKey: 'portal.workshare',
        configValue: configValue,
      }
    }
  }

  @action
  saveConfig = () => {
    const params = this.buildConfigParams();
    console.log(params, "saveConfig");
    API.saveConfig(params)
      .then((result: any) => {
        runInAction(() => {
          if (result && result.config) {
            if (!window.TEAMS?.userConfig) {
              window.TEAMS.userConfig = {}
            }
            window.TEAMS.userConfig['portal.workshare'] = result.config.configValue;
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  praise = (id: any) => {
    const params = {
      praise: {
        entityId: id,
        userId: window.TEAMS.currentUser.id,
        module: 'share',
      }
    };
    API.praise(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            this.getData();
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  publish = (value: any, attachments: any, data: any) => {
    if (!value || value.trim() === '') {
      message({
        type: 'info',
        content: getLabel('183337', '请填写内容后再提交'),
      });
      return;
    }
    if (value.length > 1000) {
      message({
        type: 'info',
        content: getLabel('183338', '内容过长，单次输入不超过1000字'),
      });
      return;
    }
    const params: any = {
      blog: {
        content: data.content,
        imAtContent: data.imAtContent,
        shareScope: this.shareScope,
        userIdIndex: [],
        userIds: [],
      },
      publishtype: this.publishtype
    };
    if (attachments && attachments != '') {
      params.blog['attachmentIds'] = attachments;
    }
    this.handSaveAtParams(params, data);
    API.publish(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            message({
              type: 'success',
              content: getLabel('173490', '发布成功!'),
            });
            this.getData();
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  editAfterPublish = (id: any, data: any) => {
    const params = {
      blog: {
        id: id,
        content: data.content,
        userIdIndex: [],
        userIds: [],
      },
    }
    this.handSaveAtParams(params, data);
    API.editAfterPublish(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            message({
              type: 'success',
              content: getLabel('22009', '修改成功'),
            });
            this.getData();
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  handSaveAtParams = (params: any, data: any) => {
    if (data && data.atLinkList && data.atLinkList.length > 0) {
      let userId: any = [];
      let userIdIndex: any = [];
      let context = data.imAtContent;
      data.atLinkList.forEach((link: any) => {
        let id = link.userId;
        let s = ':@' + id + ';';
        userId.push(id);
        let index = context.indexOf(s);
        userIdIndex.push(id + '-' + (index + 1));
        context = context.replace(s, '');
      })
      params.blog.userIds = userId;
      params.blog.userIdIndex = userIdIndex;
    }
  }

  @action
  handLoadAtParams = () => {
    if (this.teamSharingList && this.teamSharingList.length > 0) {
      let userDataE10: any = [];
      this.teamSharingList.forEach(comment => {
        comment.contentE10 = comment.content;
        comment.contentE10Edit = comment.content;
        let userData = comment.userData;
        if (userData) {
          userData = JSON.parse(userData);
          if (userData && userData.length > 0) {
            userData.forEach((ud: any) => {
              ud.atType = 'user';
              userDataE10.push(ud);
            })
            comment.userDataE10 = userDataE10;
            userData.reverse().forEach((ud: any) => {
              let index = ud.userIdIndex - 1;
              let idstr = ':@' + ud.userId + ';'
              let name = '@' + ud.userName;
              comment.contentE10 = comment.contentE10.slice(0, index) + idstr + comment.contentE10.slice(index)
              comment.contentE10Edit = comment.contentE10Edit.slice(0, index) + name + comment.contentE10Edit.slice(index)
            })

          }
        }
      })

      console.log(this.teamSharingList);
    }
  }

  @action
  updateUserId = (value: any) => {
    this.rangeUserId = value;
  }

}

const instance = new TeamSharingListStore();

export default instance;